import {motion} from 'motion/react';
import React, {Suspense} from 'react';

import {Loading} from 'src/components/loading/loading';
import {FilmStrip} from 'src/components/film-strip/film-strip';

import styles from './coming-soon.module.scss';
import assetLoader from '@/utils/asset-loader';

const items = Array.from({length: 42}, (_, i) => ({
    id: i.toString(),
    title: `Item ${i + 1}`,
    image: assetLoader({
        src: `/ci/images/landing/placeholders/hero/200/${i + 1}.jpeg`,
    }),
}));

const ComingSoon: React.FC = () => {
    return (
        <motion.section className={styles.comingSoonSection}>
            <div className={styles.sectionTitle}>Coming soon</div>

            <div className={styles.carouselContainer}>
                <Suspense fallback={<Loading />}>
                    <FilmStrip items={items} />
                </Suspense>
            </div>
        </motion.section>
    );
};

export {ComingSoon};
